import queryString from 'query-string';

var OrganizationType;
(function (OrganizationType) {
    OrganizationType["BANK"] = "bank";
    OrganizationType["MFO"] = "mfo";
    OrganizationType["INSURANCE"] = "insuranceCompany";
    OrganizationType["SCHOOL"] = "educationalOrganization";
    OrganizationType["BROKER"] = "broker";
    OrganizationType["NPF"] = "npf";
    OrganizationType["LEASING"] = "leasing";
    OrganizationType["MARKETPLACE"] = "marketplace";
    OrganizationType["BANKRUPTCY"] = "bankruptcy";
    OrganizationType["UNIVERSITY"] = "university";
    OrganizationType["BOOKMAKER"] = "bookmaker";
    OrganizationType["FOOD_RATION"] = "foodRation";
})(OrganizationType || (OrganizationType = {}));
const ORGANIZATION_TYPE_TO_PATH = {
    [OrganizationType.BANK]: 'bank',
    [OrganizationType.INSURANCE]: 'strakhovaja-kompanija',
    [OrganizationType.MFO]: 'zaimy',
    [OrganizationType.SCHOOL]: 'kursy',
    [OrganizationType.BROKER]: 'broker',
    [OrganizationType.NPF]: 'npf',
    [OrganizationType.LEASING]: 'leasing',
    [OrganizationType.MARKETPLACE]: 'marketplace',
    [OrganizationType.BANKRUPTCY]: 'bankruptcy',
    [OrganizationType.UNIVERSITY]: 'university',
    [OrganizationType.BOOKMAKER]: 'bukmeker',
    [OrganizationType.FOOD_RATION]: 'raciony-kompanii',
};
const createReviewLink = ({ organizationType, organizationId, productTag, productId, }) => {
    const type = ORGANIZATION_TYPE_TO_PATH[organizationType];
    const query = queryString.stringify({
        reviewObjectId: organizationId,
        ...(organizationId && { tag: productTag }),
        ...(organizationId && productTag && { specificProduct: productId }),
    });
    return `/${type}/otzyvy/add/${query?.length ? `?${query}` : ''}`;
};

export { OrganizationType, createReviewLink };
//# sourceMappingURL=createReviewLink.js.map
